import { Component, OnInit } from '@angular/core';
import { StreamService } from 'src/app/services/stream.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Stream } from 'src/app/models/stream';
import { CategoryService } from 'src/app/services/category.service';
import { Category } from 'src/app/models/category';

@Component({
  selector: 'app-featured-learning-series',
  templateUrl: './featured-learning-series.component.html',
  styleUrls: ['./featured-learning-series.component.scss']
})
export class FeaturedLearningSeriesComponent implements OnInit {
  private perPage=99999999;
  public loading:boolean=true;
  public streams:Stream[];
  public streamsToAdd=[];
  public loadedCategories:boolean=false;
  public categories:Category[];
  public activeCategoryId:number;
  public featuredStreams=[];

  constructor(
    private _categories: CategoryService,
    private _series: StreamService,
    private _notify: NotificationService
  ) { }

  ngOnInit() {
    this.getStreams();
    this.getCategories(1);
  }

  public getCategories(page){
    this._categories.getCategories().subscribe((cats:any) => {
      this.categories=cats;
      this.loadedCategories=true;
      this.activeCategoryId=this.categories[0].id;
    });
  }

  getStreams(){
    this._series.getStreamsFlat().subscribe(res=>{
      this.streams=res;
      this.getSortFeaturedStreams();
      this.loading=false;
    });
  }

  private getSortFeaturedStreams(){
    this.featuredStreams=[];
    this.streams.forEach((stream:any)=>{
      if(stream.featured_order) {
        this.featuredStreams[stream.featured_order]=stream;
      }
    });
  }

  public updateSeriesToAdd(event:any){
    this.streamsToAdd=event.value;
  }

  public addFeaturedSeries(){
    this.streamsToAdd.forEach((add:any)=>{
      this.updateStream(add.id);
    });
  }

  public moveStreamUp(id:number,order:number){
    this.streams.forEach((stream:any, index)=>{
      if(stream.featured_order==(order-1)) this.streams[index].featured_order=order;
    });
    this.streams.forEach((stream:any, index)=>{
      if(stream.id==id) this.streams[index].featured_order=(order-1);
    });
    this.getSortFeaturedStreams();
  }

  public moveStreamDown(id:number,order:number){
    this.streams.forEach((course:any, index)=>{
      if(course.featured_order==(order+1)) this.streams[index].featured_order=order;
    });
    this.streams.forEach((course:any, index)=>{
      if(course.id==id) this.streams[index].featured_order=(order+1);
    });
    this.getSortFeaturedStreams();
  }

  public removeStream(id:number){
    this.streams.forEach((course:any, index)=>{
      if(course.id==id) this.streams[index].featured_order=0;
    });
  }

  private updateStream(id:number){
    this.streams.forEach((stream:any, index)=>{
      if(stream.id==id) {
        this.streams[index].featured_order=this.featuredStreams.length+1;
      }
    });
    this.getSortFeaturedStreams();
  }

  public updateFeaturedStreams(){
    let updateArray=[];
    this.streams.forEach((stream:any)=>{
      if(stream.featured_order && stream.featured_order > 0) {
        updateArray.push({'id':stream.id,'featured_order':stream.featured_order});
      }
    });
    this._series.updateFeaturedSeries(updateArray).subscribe(
      (res:any)=>{
        if (res.message == 'updated') this._notify.showMessage('Featured series updated.','OK');
      }
    );
  }

}
